import { component$, Slot } from "@builder.io/qwik";
import { cn } from "~/lib/cn";

interface HeadingProps {
  preHeadline?: string | null;
  headline?: string | null;
  subheadline?: string | null;
  class?: string;
  isH1?: boolean;
}

export const HeadingElement = component$((props: any) => {
  if (props.isH1) {
    return (
      <h1 {...props}>
        <Slot />
      </h1>
    );
  } else {
    return (
      <h2 {...props}>
        <Slot />
      </h2>
    );
  }
});

export const Heading = component$<HeadingProps>(
  ({ preHeadline, headline, subheadline, ...props }) => {
    return (
      <div class={cn(props.class, "text-center")}>
        <p class="mb-4 text-sm font-medium uppercase tracking-wide text-purple-700">
          {preHeadline}
        </p>
        <HeadingElement
          isH1={props.isH1}
          class="font-heading mx-auto mb-4 max-w-2xl text-3xl font-medium tracking-tight sm:text-4xl md:text-5xl"
        >
          {headline}
        </HeadingElement>
        <p class="text-muted-foreground mx-auto mb-8 max-w-xl text-xl">
          {subheadline}
        </p>
      </div>
    );
  },
);

export default Heading;
